var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4500;stroke:#FF4500;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.6,78.2H7.4c-4.1,0-7.4-3.3-7.4-7.4V19.2c0-4.1,3.3-7.4,7.4-7.4h75.2c4.1,0,7.4,3.3,7.4,7.4v51.7 C90,74.9,86.7,78.2,82.6,78.2z M7.4,13.8c-3,0-5.4,2.4-5.4,5.4v51.7c0,3,2.4,5.4,5.4,5.4h75.2c3,0,5.4-2.4,5.4-5.4V19.2 c0-3-2.4-5.4-5.4-5.4L7.4,13.8L7.4,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,53.8c-5.1,0-9.9-2.1-13.3-5.9L2.1,15.4l1.5-1.3l29.6,32.5c3,3.3,7.4,5.2,11.9,5.2s8.8-1.9,11.9-5.2 l29.6-32.5l1.5,1.3L58.3,47.9C54.9,51.6,50.1,53.8,45,53.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.1,
    y: 59.9,
    transform: "matrix(0.7052 -0.7091 0.7091 0.7052 -38.0803 30.195)",
    className: "st0",
    width: 40.8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.7,
    y: 40.5,
    transform: "matrix(0.7089 -0.7053 0.7053 0.7089 -21.7677 69.0189)",
    className: "st0",
    width: 2,
    height: 40.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.74188d23b099498f9989ce0e160f0261.svg";
export { ForwardRef as ReactComponent };